// what the old shell did for every page (side scroll, Latin digits, Persian letters).
import { latinDigits } from '../rules.ts';
import { $ } from './core.ts';

// ---------------- T-072: what the old shell did for every page ----------------
// Persian/Arabic digits typed into a text field become Latin at once (main-14040620.js did this for every input; the
// server and the page scripts expect Latin digits).
// T-072: the keyboard never matters — Persian/Arabic digits become Latin and Arabic ي/ى/ك become Persian ی/ک while typing,
// in every text input and textarea (the server does the same to every value it receives). A password keeps its letters
// as typed (its digits were already made Latin by the old global helper, so that stays as it was).
const ARABIC_LETTERS = /[يىك]/g;
const unifyLetters = (v: string): string => v.replace(ARABIC_LETTERS, c => (c === 'ك' ? 'ک' : 'ی'));
// the sidebar menu scrolls on its own (brand and footer stay): fades show there is more; the current page is brought
// into view when a page opens (T-072)
export function initSideScroll(): void {
  const box = $('[data-ds-side-scroll]');
  if (!box) return;
  const mark = (): void => {
    box.classList.toggle('can-up', box.scrollTop > 2);
    box.classList.toggle('can-down', box.scrollTop + box.clientHeight < box.scrollHeight - 2);
  };
  const cur = $('[aria-current="page"]', box);
  if (cur) {
    const r = cur.getBoundingClientRect(),
      b = box.getBoundingClientRect();
    if (r.bottom > b.bottom - 24 || r.top < b.top) {
      box.style.scrollBehavior = 'auto';
      box.scrollTop += r.top - b.top - b.height / 3;
      box.style.scrollBehavior = '';
    }
  }
  box.addEventListener('scroll', mark, { passive: true });
  new ResizeObserver(mark).observe(box);
  box.addEventListener('transitionend', mark);
  box.addEventListener('click', () => setTimeout(mark, 260));
  mark();
}
export function initDigits(): void {
  const SKIP = /^(file|checkbox|radio|hidden|button|submit|reset|color|range|image)$/;
  document.addEventListener(
    'input',
    e => {
      const i = e.target as HTMLInputElement;
      const text = i.tagName === 'TEXTAREA' || (i.tagName === 'INPUT' && !SKIP.test(i.type));
      if (!text || i.dataset.keepDigits !== undefined || !/[۰-۹٠-٩يىك]/.test(i.value)) return;
      const pos = i.selectionStart;
      const next = i.type === 'password' ? latinDigits(i.value) : unifyLetters(latinDigits(i.value));
      if (next === i.value) return;
      i.value = next;
      try {
        if (pos !== null) i.setSelectionRange(pos, pos);
      } catch {
        /* not a text type */
      }
    },
    true,
  );
}
